(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  const carousel = document.querySelector('.infinite-hero-carousel');
  if (!carousel) return;
  const track = carousel.querySelector('.infinite-hero-track');
  const slides = Array.from(track.children);
  const leftArrows = carousel.querySelectorAll('.infinite-hero-arrow.left');
  const rightArrows = carousel.querySelectorAll('.infinite-hero-arrow.right');
  const dots = Array.from(carousel.querySelectorAll('.infinite-hero-dot'));
  let current = 0;
  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;
  let slideWidth = 0;
  let clones = 0;
  let lastAnimatedIndex = null;
  let headingTimeout = null;

  function getSlideWidth() {
    const slide = track.querySelector('.infinite-hero-slide');
    if (!slide) return 0;
    const style = getComputedStyle(slide);
    return slide.offsetWidth + parseInt(style.marginLeft) + parseInt(style.marginRight);
  }

  function cloneSlides() {
    Array.from(track.querySelectorAll('.clone')).forEach(clone => clone.remove());
    clones = 2;
    const originalSlides = Array.from(track.querySelectorAll('.infinite-hero-slide:not(.clone)'));
    for (let i = 0; i < clones; i++) {
      const first = originalSlides[i % originalSlides.length].cloneNode(true);
      first.classList.add('clone');
      track.appendChild(first);
      const last = originalSlides[originalSlides.length - 1 - (i % originalSlides.length)].cloneNode(true);
      last.classList.add('clone');
      track.insertBefore(last, track.firstChild);
    }
  }

  function updateSlideWidthAndClones() {
    cloneSlides();
    slideWidth = getSlideWidth();
  }

  window.addEventListener('resize', () => {
    updateSlideWidthAndClones();
    setPosition(false);
  });

  function setPosition(animate = true) {
    slideWidth = getSlideWidth();
    if (!animate) track.style.transition = 'none';
    currentTranslate = -slideWidth * (current + clones);
    track.style.transform = `translateX(${currentTranslate}px)`;
    if (!animate) {
      void track.offsetWidth;
      track.style.transition = '';
    }
    updateClasses();
    updateDots();
  }

  function goTo(index) {
    current = (index + slides.length) % slides.length;
    setPosition(true);
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function updateClasses() {
    const allSlides = Array.from(track.children);
    // Remove 'center' and 'animate-pop' from all slides/headings
    allSlides.forEach(slide => {
      slide.classList.remove('center');
      const heading = slide.querySelector('.infinite-hero-slide-heading');
      if (heading) {
        heading.classList.remove('animate-pop');
      }
    });
    const centerIndex = current + clones;
    if (allSlides[centerIndex]) {
      allSlides[centerIndex].classList.add('center');
      // No more animate-pop logic here
    }
  }

  function updateDots() {
    dots.forEach((dot, i) => dot.classList.toggle('active', i === current));
  }

  function onDragStart(e) {
  isDragging = true;
  startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
  prevTranslate = currentTranslate;
  animationID = requestAnimationFrame(animation);
  track.style.transition = 'none';
  // Add drag distance tracking
  window._carouselDragMoved = false;
  }
  function onDragMove(e) {
  if (!isDragging) return;
  const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
  const dx = x - startX;
  currentTranslate = prevTranslate + dx;
  // If moved more than 5px, consider as drag
  if (Math.abs(dx) > 5) window._carouselDragMoved = true;
  }
  function onDragEnd() {
    cancelAnimationFrame(animationID);
    isDragging = false;
    const movedBy = currentTranslate - prevTranslate;
    // Only change slide if user dragged enough and not just clicked
    if (window._carouselDragMoved) {
      if (movedBy < -slideWidth / 4) {
        next();
      } else if (movedBy > slideWidth / 4) {
        prev();
      } else {
        setPosition(true);
      }
    } else {
      setPosition(true);
    }
    track.style.transition = '';
  }
  function animation() {
    track.style.transform = `translateX(${currentTranslate}px)`;
    if (isDragging) requestAnimationFrame(animation);
  }

  function onTransitionEnd() {
    const allSlides = Array.from(track.children);
    if (current === slides.length) {
      current = 0;
      // Use rAF to ensure transition is removed and restored at the right time
      requestAnimationFrame(() => {
        track.style.transition = 'none';
        setPosition(false);
        requestAnimationFrame(() => {
          track.style.transition = '';
        });
      });
    } else if (current === -1) {
      current = slides.length - 1;
      requestAnimationFrame(() => {
        track.style.transition = 'none';
        setPosition(false);
        requestAnimationFrame(() => {
          track.style.transition = '';
        });
      });
    }
    updateClasses();
    updateDots();
  }

  track.addEventListener('mousedown', onDragStart);
  track.addEventListener('touchstart', onDragStart);
  window.addEventListener('mousemove', onDragMove);
  window.addEventListener('touchmove', onDragMove);
  window.addEventListener('mouseup', onDragEnd);
  window.addEventListener('touchend', onDragEnd);
  track.addEventListener('transitionend', onTransitionEnd);
  leftArrows.forEach(arrow => arrow.addEventListener('click', prev));
  rightArrows.forEach(arrow => arrow.addEventListener('click', next));
  dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

  // Keyboard arrow navigation
  window.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') {
      prev();
    } else if (e.key === 'ArrowRight') {
      next();
    }
  });

  // Init
  setTimeout(() => {
    updateSlideWidthAndClones();
    setPosition(false);
  }, 100);

  // Set background images on pseudo-elements
  function setBgImages() {
    Array.from(track.children).forEach(slide => {
      const bg = slide.getAttribute('data-bg');
      if (bg) {
        slide.style.setProperty('--hero-bg', `url('${bg}')`);
      }
    });
  }
  setBgImages();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-horizontal"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Prevent multiple initializations
  if (window.parallaxHorizontalInitialized) return;
  window.parallaxHorizontalInitialized = true;

  let resizeTimeout;
  let isInitialized = false;

  function createInfiniteMarquee(track) {
    if (!track || track.children.length === 0) return;
    
    const originalItems = Array.from(track.children);
    
    // Clear existing content
    track.innerHTML = '';
    
    // Create enough copies to ensure seamless loop (at least 2 full sets)
    const copies = 3;
    for (let i = 0; i < copies; i++) {
      originalItems.forEach(item => {
        const clone = item.cloneNode(true);
        track.appendChild(clone);
      });
    }
  }

  function getAnimationSpeed() {
    // Check if user prefers reduced motion
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return '0s';
    }
    
    // Check if mobile/touch device
    const isMobile = window.innerWidth <= 749 || ('ontouchstart' in window);
    if (isMobile) {
      return '20s';
    }
    
    return '25s';
  }

  function setAnimationSpeed(track) {
    if (!track) return;
    
    const speed = getAnimationSpeed();
    const newAnimation = `marquee-scroll ${speed} linear infinite`;
    
    // Only update if speed actually changed
    const currentAnimation = track.style.animation;
    if (currentAnimation !== newAnimation) {
      track.style.animation = newAnimation;
    }
  }

  function initializeMarquee() {
    if (isInitialized) return;
    
    const track = document.querySelector('.parallax-horizontal-track');
    if (track) {
      createInfiniteMarquee(track);
      setAnimationSpeed(track);
    }
    
    isInitialized = true;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMarquee);
  } else {
    initializeMarquee();
  }

  // Handle window resize with proper debouncing
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const track = document.querySelector('.parallax-horizontal-track');
      setAnimationSpeed(track);
    }, 300);
  });

  // Handle visibility changes to pause/resume animation
  document.addEventListener('visibilitychange', function() {
    const track = document.querySelector('.parallax-horizontal-track');
    if (track) {
      if (document.hidden) {
        track.style.animationPlayState = 'paused';
      } else {
        track.style.animationPlayState = 'running';
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-line"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Prevent multiple initializations
  if (window.parallaxLineInitialized) return;
  window.parallaxLineInitialized = true;

  let resizeTimeout;
  let isInitialized = false;

  function createInfiniteMarquee(track) {
    if (!track || track.children.length === 0) return;
    
    const originalItems = Array.from(track.children);
    
    // Clear existing content
    track.innerHTML = '';
    
    // Create enough copies to ensure seamless loop
    const copies = 4;
    
    for (let i = 0; i < copies; i++) {
      originalItems.forEach(item => {
        const clone = item.cloneNode(true);
        track.appendChild(clone);
      });
    }
  }

  function getAnimationSpeed(isYellow) {
    // Check if user prefers reduced motion
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return '0s';
    }
    
    // Check if mobile/touch device
    const isMobile = window.innerWidth <= 600 || ('ontouchstart' in window);
    
    if (isMobile) {
      return isYellow ? '80s' : '100s';
    }
    
    return isYellow ? '30s' : '40s';
  }

  function setAnimationSpeed(track, isYellow) {
    if (!track) return;
    
    const speed = getAnimationSpeed(isYellow);
    const animationName = isYellow ? 'marquee-right' : 'marquee-left';
    
    // Only update if speed actually changed
    const currentAnimation = track.style.animation;
    const newAnimation = `${animationName} ${speed} linear infinite`;
    
    if (currentAnimation !== newAnimation) {
      track.style.animation = newAnimation;
    }
  }

  function initializeMarquee() {
    if (isInitialized) return;
    
    const yellowTrack = document.querySelector('.parallax-track--yellow');
    const blackTrack = document.querySelector('.parallax-track--black');
    
    if (yellowTrack) {
      createInfiniteMarquee(yellowTrack);
      setAnimationSpeed(yellowTrack, true);
    }
    
    if (blackTrack) {
      createInfiniteMarquee(blackTrack);
      setAnimationSpeed(blackTrack, false);
    }
    
    isInitialized = true;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMarquee);
  } else {
    initializeMarquee();
  }

  // Handle window resize with proper debouncing
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const yellowTrack = document.querySelector('.parallax-track--yellow');
      const blackTrack = document.querySelector('.parallax-track--black');
      
      setAnimationSpeed(yellowTrack, true);
      setAnimationSpeed(blackTrack, false);
    }, 300);
  });

  // Handle visibility changes to pause/resume animations
  document.addEventListener('visibilitychange', function() {
    const yellowTrack = document.querySelector('.parallax-track--yellow');
    const blackTrack = document.querySelector('.parallax-track--black');
    
    if (document.hidden) {
      if (yellowTrack) yellowTrack.style.animationPlayState = 'paused';
      if (blackTrack) blackTrack.style.animationPlayState = 'paused';
    } else {
      if (yellowTrack) yellowTrack.style.animationPlayState = 'running';
      if (blackTrack) blackTrack.style.animationPlayState = 'running';
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
